const CryptoJS = require("crypto-js");

function isBase64Encoded(input) {
  const base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/;
  return base64Regex.test(input);
}

function decryptData(cipherText, key) {
  try {
    if (!cipherText || !key) {
      throw new Error("Cipher text and key are required.");
    }

    // Check if the input is Base64 encoded
    const isEncoded = isBase64Encoded(cipherText);

    if (isEncoded) {
      // Parse base64-encoded cipher text
      const encryptedBytes = CryptoJS.enc.Base64.parse(cipherText);

      // Extract IV from the cipher text
      const blockSize = 128; // AES block size is 128 bits
      const iv = CryptoJS.lib.WordArray.create(
        encryptedBytes.words.slice(0, blockSize / 32)
      );

      // Extract the actual cipher text (excluding IV)
      const encrypted = CryptoJS.lib.WordArray.create(
        encryptedBytes.words.slice(blockSize / 32)
      );

      // Convert key from Base64 to WordArray
      const keyBytes = CryptoJS.enc.Base64.parse(key);

      // Decrypt using AES
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encrypted },
        keyBytes,
        { iv: iv }
      );

      // Check if decryption was successful
      if (!decrypted) {
        throw new Error("Decryption failed. Check the key and cipher text.");
      }

      // Convert the decrypted result to a string
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

      // Return the decrypted text
      return decryptedText;
    } else {
      // If not Base64 encoded, return the input as is
      return cipherText;
    }
  } catch (error) {
    // Log the error for debugging or monitoring
    console.error("Decryption failed:", error.message);

    // Rethrow the error for higher-level handling if needed
    return;
  }
}

export default decryptData;
